import { isNonEmptyObject } from './checks'

declare global {
  interface Window {
    dataLayer: unknown[] | undefined
  }
}

interface DataLayerProps {
  (props: object): void
}
/**
 * Pushes an object to the global `dataLayer` array on the `window` object.
 *
 * This function ensures that the `dataLayer` array exists on the `window` object.
 * If the `dataLayer` array does not exist or is not a non-empty array, it initializes it as an empty array.
 * Then, it pushes the provided `props` object to the `dataLayer` array.
 *
 */
const pushToDataLayer: DataLayerProps = (props) => {
  if (!window || !isNonEmptyObject(props)) {
    return
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(props)
    return
  }

  window.dataLayer = [props]
}

export default pushToDataLayer
